<template>
  <page-wrapper :title="title">
    <div class="container" v-if="receipt">
      <div class="mb-3">
        <div class="offline-user mb-3" v-if="isOfflineUser">ซื้อนอกระบบ (ไม่มีผู้ใช้ในระบบ)</div>
        <div class="offline-user mb-3" v-if="receipt.isManualPayment">ซื้อนอกระบบ</div>
        <div class="col" style="padding: 0;">
            <div class="label">เลือกภาษาที่ต้องการออกใบเสร็จ</div>
            <div class="mt-1">
              <el-select
                id="language"
                name="language"
                v-model="selectedLanguage"
                placeholder=""
                style="width: 240px; height: 40px;"
              >
                <el-option
                  v-for="item in languageOptions"
                  :key="item.value"
                  :value="item"
                >
                  <template>
                    <span style="color: #4A4A4A;">
                      <img
                        :src="item.icon"
                        width="24"
                        height="24"
                        style="margin-right: 12px;"
                      />
                      {{ item.label }} 
                    </span>
                  </template>
                </el-option>
                <template #prefix>
                  <span
                    v-if="selectedLanguage"
                    style="
                      display: flex;
                      align-items: center;
                      height: 100%;
                      padding-left: 12px;
                      color: #4A4A4A;
                    "
                  >
                    <img
                      :src="selectedLanguage.icon"
                      width="24"
                      height="24"
                      style="margin-right: 12px;"
                    />
                    {{ selectedLanguage.label }}
                  </span>
                </template>
              </el-select>
            </div>
          </div>
        <div class="row mt-4">
          <div class="col col-lg-4">
            <div class="label">
              วันที่
              <sc-button
                v-bind:disabled="isViewOnlyByRole"
                variant="secondary"
                size="sm"
                @click="handleClickChangeIssuedAtButton"
                >แก้ไขวันที่</sc-button
              >
            </div>
            <div class="text">{{ receipt.issuedAt }}</div>
          </div>
          <div class="col col-lg-4">
            <div class="label">เลขที่</div>
            <div class="text">{{ receipt.no }}</div>
          </div>
          <div class="col col-lg-4">
            <div class="label">ผู้จัดหาบริการ</div>
            <div class="text">{{ receipt.sellerTradePartyName }}</div>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <div class="row">
          <div class="col col-lg-4">
            <div class="label">
              ผู้รับบริการ
              <sc-button
                variant="secondary"
                size="sm"
                :disabled="canNotEditAddress || isViewOnlyByRole"
                @click="handleClickChangeClientNameButton"
                >แก้ไขชื่อ</sc-button
              >
              <div v-if="isHasToEditOwnerName" class="offline-user-detail">
                *ต้องแก้ไขชื่อผู้รับบริการก่อนส่ง eztax
              </div>
            </div>
            <div class="text mb-4">{{ form.name }}</div>
          </div>
          <div class="col col-lg-4" v-show="isCreditNote">
            <div class="label">เลขที่เอกสารเดิม</div>
            <div class="text">{{ receipt.referenceDocumentNumber }}</div>
          </div>
        </div>
        <div class="label">
          ที่อยู่ผู้รับบริการ
          <sc-button
            variant="secondary"
            size="sm"
            :disabled="canNotEditAddress || isViewOnlyByRole"
            @click="handleClickChangeAddressButton"
            >แก้ไขที่อยู่</sc-button
          >
        </div>
        <div>
          <div class="warning mt-1" v-if="!isLangDefault()">* กรุณาแก้ไขที่อยู่ตามภาษาที่เลือก</div>
          <div class="text">{{ receipt.client.addressLine1 }}</div>
          <div class="text">{{ receipt.client.addressLine2 }}</div>
        </div>
        <div class="mt-4" v-show="isCreditNote">
          <div class="label">หมายเหตุของการยกเลิกเอกสาร</div>
          <div class="text">{{ receipt.purpose }}</div>
        </div>
        <div class="label mt-4">
          เลขประจำตัวผู้เสียภาษี
          <sc-button
            variant="secondary"
            size="sm"
            :disabled="canNotEditAddress || isViewOnlyByRole"
            @click="handleClickChangeTaxIdButton"
          >แก้ไขเลขประจำตัวผู้เสียภาษี</sc-button>
          <div v-if="isHasToEditOwnerTaxId" class="offline-user-detail">
            *ต้องแก้ไขเลขประจำตัวผู้เสียภาษีก่อนส่ง eztax
          </div>
        </div>
        <div class="text mb-4" v-if="!isEditTaxId">
          <button
            v-if="!isHiddenDrecryptButton"
            class="button-content"
            @click="handleDecryptTaxId"
          >
            <span style="font-weight: bold">แสดงข้อมูล</span>
            <i class="fa fa-eye-slash" aria-hidden="true"></i>
          </button>
          <div v-if="receipt.client.taxId" class="identifier-id">
            {{ receipt.client.taxId }}
          </div>
        </div>
        <div class="text mb-4" v-else>{{ form.taxId }}</div>
        <sc-button
          variant="primary"
          size="sm"
          :disabled="canNotEditAddress || isViewOnlyByRole"
          :hidden=!receipt.invoiceId
          v-if="!hasBranchNumber"
          @click="handleClickAddBranchNumberButton"
        >เพิ่มเลขสาขา</sc-button>
        <div v-else>
          <div class="label">
            เลขสาขา
            <sc-button
              variant="secondary"
              size="sm"
              :disabled="canNotEditAddress"
              @click="handleClickEditBranchNumberButton"
            >แก้ไขเลขสาขา</sc-button>
          </div>
          <div class="text mb-4">{{ form.branchNumber }}</div>
        </div>
      </div>
      <hr />
      <div class="mb-3">
        <div class="row">
          <div class="col col-lg-3">
            <div class="label">รายการ</div>
              <router-link
                target="_blank"
                v-if="receipt.item.subscriptionId"
                :to="{
                  name: 'SubscriberDetailPage',
                  params: { id: receipt.item.subscriptionId },
                }"
              >{{ receipt.item.name }}</router-link>
            <div class="text" v-else>{{ receipt.item.name }}</div>
          </div>
          <div class="col col-lg-4">
            <div class="label">อายุการใช้งาน</div>
            <div class="text">{{ receipt.item.duration }}</div>
          </div>
          <div class="col col-lg-2">
            <div class="label">จำนวนแพ็กเกจ</div>
            <div class="text">{{ receipt.item.quantity }}</div>
          </div>
          <div class="col col-lg-3 text-right">
            <div class="label">ราคา</div>
            <div class="text">{{ receipt.item.price }}</div>
          </div>
        </div>
      </div>
      <hr />
      <div v-for="item in itemPresenters" :key="item.id">
        <div class="mb-3">
          <div class="row">
            <div class="col col-lg-8">
              <div class="text">{{ item.title }}</div>
            </div>
            <div class="col col-lg-4 text-right">
              <div class="text">{{ item.amount }}</div>
            </div>
          </div>
        </div>
        <hr />
      </div>
      <div class="text-right">
        <div class="mb-3" v-show="isCreditNote">
          <div class="label">จำนวนเงินก่อนภาษีตามเอกสารเดิม</div>
          <div class="text">{{ receipt.summary.referenceBasisAmount }}</div>
          <hr />
        </div>
        <div class="mb-3">
          <div class="label">จำนวนเงินก่อนภาษีที่ถูกต้อง</div>
          <div class="text">{{ receipt.summary.amountBeforeVat }}</div>
        </div>
        <hr />
        <div class="mb-3" v-show="isCreditNote">
          <div class="label">ผลต่างจำนวนเงินก่อนภาษี</div>
          <div class="text">{{ receipt.summary.differenceBasisAmount }}</div>
          <hr />
        </div>
        <div class="mb-3">
          <div class="label">ภาษีมูลค่าเพิ่ม (7%)</div>
          <div class="text">{{ receipt.summary.vat }}</div>
        </div>
        <hr />
        <div class="mb-3">
          <div class="label">จำนวนเงินรวมทั้งสิ้น</div>
          <div class="text">{{ receipt.summary.grandTotal }}</div>
        </div>
      </div>
      <div>
        <div class="actions text-right">
          <sc-button
            variant="secondary"
            class="mb-4"
            v-if="hasBranchNumber"
            @click="handleClickAddSelectWithholdingAlbumDialog"
          >ใบหัก ณ ที่จ่าย</sc-button>
          <sc-button
            variant="warning"
            class="mb-4"
            v-if="(
              showConfirmReceiptButton
              || showSendReceiptButton
              || receipt.isOfflineReceipt
            ) && !isViewOnlyByRole"
            @click="handleClickAddOfflinePdfReceiptButton"
          >ออกใบเสร็จนอกระบบ</sc-button>
          <sc-button
            variant="danger"
            class="mb-4"
            v-if="showDeletePreviewReceiptButton && showConfirmReceiptButton && !isViewOnlyByRole"
            @click="handleClickDeleteReceiptButton"
          >ลบตัวอย่างใบเสร็จนี้</sc-button>
          <a
            @click.prevent="handlePreviewReceipt(
              receipt.pdfUrl,
              selectedLanguage.value
            )"
            class="preview mb-4"
            target="_blank"
            v-if="showPreviewReceiptButton && (showSendReceiptButton || showConfirmReceiptButton)"
            @click="handleClickPreviewReceiptButton"
            >ดูตัวอย่างใบเสร็จ</a
          >
          <el-dialog
            title="Validation Error"
            :visible.sync="showErrorDialog"
            width="40%"
            @close="showErrorDialog = false"
            :modal="false"
            :append-to-body="true"
          >
            <span>{{ nameError }}</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="showErrorDialog = false">OK</el-button>
            </span>
          </el-dialog>
          <div v-if="!receipt.isDuplicateReceiptByInvoice">
            <sc-button
              :disabled="
                isSending
                || isHasToEditOwnerName
                || isHasToEditOwnerTaxId
                || isViewOnlyByRole
                || isBlockSendReceiptByHalfHourFirst
              "
              variant="primary"
              v-if="showSendReceiptButton"
              @click="handleClickSendReceiptButton('SEND')"
              >ส่ง EZTax</sc-button
            >
            <sc-button
              :disabled="
                isSending
                || isHasToEditOwnerName
                || isHasToEditOwnerTaxId
                || isViewOnlyByRole
                || isBlockSendReceiptByHalfHourFirst
              "
              variant="secondary"
              v-else-if="showConfirmReceiptButton"
              @click="handleClickSendReceiptButton('CONFIRM')"
            >ยืนยันข้อมูล</sc-button>
            <div class="text-right"
              v-else-if="isSuccessToSentEztax"
              >ส่งใบเสร็จให้ EZTax แล้ว
            </div>
            <div
              class="text-right"
              v-else
            >
              ไม่พบสถานะปัจจุบัน (กรุณาติดต่อ TS)
            </div>
            <div v-if="isBlockSendReceiptByHalfHourFirst" class="text-right">
              ปิดไม่ให้ส่งใบเสร็จในครึ่งชั่วโมงแรก 00.00 - 00.30 นาที
            </div>
          </div>
          <div class="offline-user-detail" v-if="receipt.isDuplicateReceiptByInvoice">
            ไม่สามารถส่ง EZTax ได้ เพราะเลขที่ใบเสร็จซ้ำ หรือ เลขที่ invoice ซ้ำ (กรุณาติดต่อ TS)
          </div>
        </div>
        <div class="text-right" v-if="receipt.isOfflineReceipt && !receipt.fileOfflinePdfKey">ออกใบเสร็จนอกระบบแล้ว</div>
        <div class="text-right" v-else-if="receipt.isOfflineReceipt && fileOfflinePdfUrl">
          <a
            :href="fileOfflinePdfUrl"
            class="pointer"
            target="_blank"
            >ออกใบเสร็จนอกระบบแล้ว
          </a>
        </div>
      </div>
      <confirm
        :data="issuedAtDialog"
        v-if="issuedAtDialog.isShow"
        @confirm="(isConfirm) => handleConfirmIssuedAt(isConfirm)"
      >
        <div class="text-left mb-4">
          <div class="label">วันที่จากระบบ</div>
          <div class="text">{{ receipt.createdDate }}</div>
        </div>
        <div class="text-left">
          <div class="label">วันที่ใหม่</div>
          <date-picker type="date" format="dd/MM/yyyy" v-model="form.tempIssuedAt"></date-picker>
          <p
            v-if="!form.tempIssuedAt"
            style="color: red; font-size: 12px"
          >
            กรุณาเลือกวันที่
          </p>
        </div>
      </confirm>
      <confirm
        :data="confirmDialog"
        v-if="confirmDialog.isShow"
        @confirm="(isConfirm) => handleConfirm(isConfirm)"
      >
        <div class="text-left mb-4">
          <div class="label">ชื่อจากระบบ</div>
          <div class="text">{{ receipt.client.name }}</div>
        </div>
        <div class="text-left">
          <div class="label">ชื่อใหม่</div>
          <el-input v-model="form.tempName" class="name"></el-input>
          <p
            v-if="!form.tempName"
            style="color: red; font-size: 12px"
          >
            กรุณาใส่ชื่อลูกค้า
          </p>
        </div>
      </confirm>
      <confirm
        :data="addressDialog"
        v-if="addressDialog.isShow"
        @confirm="(isConfirm) => handleConfirmAddress(isConfirm)"
      >
        <div class="text-left">
          <div class="label mb-2" style="font-weight: 600;">เลือกประเภทของที่อยู่</div>
          <div class="address-options">
            <el-radio
              v-for="address in addressOptions"
              :key="address.value"
              :label="address.value"
              v-model="selectedAddress.temp"
            >
              {{ address.label }}
            </el-radio>
          </div>
        </div>
        <div class="text-left mt-2 mb-2" v-if="isTempIntlAddressSelected">
          <div class="label mb-2">ที่อยู่</div>
          <el-input
            type="textarea"
            v-model="addressForm.intlAddress"
            placeholder="ระบุที่อยู่"
            autocomplete="off"
            clearable
            @input="validateAddressForm($event, true)"
          />
            <p
              class="mt-1"
              v-if="intlAddressError"
              style="color: red;
              font-size: 12px"
            >
            {{ intlAddressError }}
          </p>
        </div>
        <div class="text-left mb-2" v-if="isTempIntlAddressSelected">
          <country-selector
            :countryOptions="countryOptions"
            :code="addressForm.countryCode"
            @countrySelected="handleCountrySelected"
          ></country-selector>
        </div>
        <div class="text-left mt-3 mb-2" v-if="!isTempIntlAddressSelected">
          <div class="label mb-2">ที่อยู่</div>
          <el-input
            v-model="addressForm.address"
            @input="validateAddressForm($event)"
          >
          </el-input>
          <p
            v-if="addressError"
            style="color: red;
            font-size: 12px"
          >
            {{ addressError }}
          </p>
        </div>
        <div class="text-left mb-2" v-if="!isTempIntlAddressSelected">
          <div class="label mb-2">รหัสไปรษณีย์</div>
          <el-select
            :value="addressForm.zip_code"
            @input="handleChangeAddressForm('zip_code', $event)"
            clearable
            filterable
            remote
            :remote-method="handleSearchZipCode"
          >
            <el-option v-for="code in zipCodes" :value="code" :key="code">{{
              code
            }}</el-option>
          </el-select>
          <p
            v-if="!addressForm.zip_code"
            style="color: red; font-size: 12px"
          >
            กรุณาใส่รหัสไปรษณีย์
          </p>
        </div>
        <div class="text-left mb-2" v-if="!isTempIntlAddressSelected">
          <div class="label mb-2">จังหวัด</div>
          <el-select
            :value="addressForm.province_code"
            @input="handleChangeAddressForm('province_code', $event)"
            filterable
            value-key="province_code"
            label-key="provice_name"
          >
            <el-option
              v-for="p in provinces"
              :value="p.province_code"
              :label="isEnglish ? p.province_name_en : p.province_name"
              :key="p.province_code"
              >{{ isEnglish ? p.province_name_en : p.province_name }}</el-option
            >
          </el-select>
          <p
            v-if="!addressForm.province_code"
            style="color: red; font-size: 12px"
          >
            กรุณาใส่จังหวัด
          </p>
        </div>
        <div class="text-left mb-2" v-if="!isTempIntlAddressSelected">
          <div class="label mb-2">อำเภอ</div>
          <el-select
            :value="addressForm.amphur_code"
            @input="handleChangeAddressForm('amphur_code', $event)"
            filterable
          >
            <el-option
              v-for="a in amphurs"
              :value="a.amphur_code"
              :label="isEnglish ? a.amphur_name_en : a.amphur_name"
              :key="a.amphur_code"
              >{{ isEnglish ? a.amphur_name_en : a.amphur_name }}</el-option
            >
          </el-select>
          <p
            v-if="!addressForm.amphur_code"
            style="color: red; font-size: 12px"
          >
            กรุณาใส่อำเภอ
          </p>
        </div>
        <div class="text-left" v-if="!isTempIntlAddressSelected">
          <div class="label mb-2">ตำบล</div>
          <el-select
            v-model="addressForm.tumbon"
            :value="addressForm.tumbon"
            @input="handleChangeAddressForm('tumbon', $event)"
            filterable
            value-key="tumbon_code"
            label-key="tumbon_name"
          >
            <el-option
              v-for="t in selectableTumbons"
              :value="t"
              :label="isEnglish ? t.tumbon_name_en : t.tumbon_name"
              :key="t.tumbon_code"
              >{{ isEnglish ? t.tumbon_name_en : t.tumbon_name }}</el-option
            >
          </el-select>
          <p
            v-if="!addressForm.tumbon"
            style="color: red; font-size: 12px"
          >
            กรุณาใส่ตำบล
          </p>
        </div>
      </confirm>
      <confirm
        :data="taxIdDialog"
        v-if="taxIdDialog.isShow"
        @confirm="(isConfirm) => handleConfirmTaxId(isConfirm)"
      >
        <div class="text-left mb-4">
          <div class="label">เลขประจำตัวผู้เสียภาษีจากระบบ</div>
          <div class="text mb-4" v-if="!isEditTaxId">
          <button
            v-if="!isHiddenDrecryptButton"
            class="button-content"
            @click="handleDecryptTaxId"
          >
            <span style="font-weight: bold">แสดงข้อมูล</span>
            <i class="fa fa-eye-slash" aria-hidden="true"></i>
          </button>
          <div v-if="receipt.client.taxId" class="identifier-id">
            {{ receipt.client.taxId }}
          </div>
         </div>
        </div>
        <div class="text-left">
          <div class="label">เลขประจำตัวผู้เสียภาษีใหม่</div>
          <el-input
            v-model="form.tempTaxId"
            class="name"
            @input="form.tempTaxId = form.tempTaxId.replace(/[^A-Z0-9]/g, '')"
          ></el-input>
        </div>
        <p
            v-if="!form.tempTaxId"
            style="color: red; font-size: 12px"
          >
            กรุณาใส่เลขประจำตัวผู้เสียภาษี
          </p>
      </confirm>
      <confirm
        :data="confirmDeleteReceiptDialog"
        v-if="confirmDeleteReceiptDialog.isShow"
        @confirm="handleConfirmCancel"
      >
        <div class="text-center">
          <div class="text-left">
            <div class="label mb-2">เหตุผลในการลบตัวอย่างใบเสร็จ</div>
            <el-input v-model="receiptDeleteReason" class="name"></el-input>
          </div>
        </div>
      </confirm>
      <confirm
        :data="addBranchNumberDialog"
        v-if="addBranchNumberDialog.isShow"
        @confirm="handleConfirmAddBranchNumber"
      >
        <div class="text-center">
          <el-input
            v-model="form.tempBranchNumber"
            placeholder="00000"
            class="branch-number"
            maxlength="5"
            type="number"
          ></el-input>
        </div>
      </confirm>
      <confirm
        :data="editBranchNumberDialog"
        v-if="editBranchNumberDialog.isShow"
        @confirm="(isConfirm) => handleConfirmEditBranchNumber(isConfirm)"
      >
        <div class="text-center">
          <el-input
            v-model="form.tempBranchNumber"
            placeholder="00000"
            class="branch-number"
            maxlength="5"
            type="number"
          ></el-input>
          <p
            v-if="!form.tempBranchNumber"
            style="color: red; font-size: 12px"
          >
            กรุณาใส่เลขสาขา
          </p>
        </div>
      </confirm>
      <pdf-picker-modal
        v-bind="selectPdfDialog"
        @cancel="handleCancelSelectPdfDialog"
        @confirm="handleConfirmSelectPdfDialog($event)"
        @fileNotChanged="handleFileNotChangedPdfDialog"
      ></pdf-picker-modal>
      <album-and-swipe-picker
        v-bind="selectWithholdingImageAlbumDialog"
        @cancel="handleCancelSelectWithholdingAlbumDialog"
        @confirm="handleConfirmSelectWithholdingAlbumDialog($event)"
    ></album-and-swipe-picker>
    </div>
  </page-wrapper>
</template>

<script>
import * as R from "ramda";
import { DateTime } from "luxon";
import {
  Input as ElInput,
  Autocomplete as ElAutocomplete,
  Select as ElSelect,
  Option as ElOption
} from "element-ui";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import Confirm from "@/components/helper/dialog/Confirm";
import DatePicker from "@/lib/components/DatePicker";
import { receiptTypeTH } from "@/lib/mapper";
import PdfPickerModal from "@/lib/components/PdfPickerModal";
import { uploadPublicFile, getPDF } from "@/god";
import AlbumAndSwipePicker from "@/lib/components/AlbumAndSwipePicker";
import { getKeyByUrlPath, existValueAndEmptyString, isValidReceiptUserName } from "@/lib/util";
import CountrySelector from "../../../../../lib/components/CountrySelector";
import { getCountries, getCountryByCode } from "../../../../../lib/country";
import { localization } from "@/lib/mapper";
import { backendAdminClient } from "@/dependencies";

export default {
  components: {
    PageWrapper,
    ScButton,
    Confirm,
    ElInput,
    ElAutocomplete,
    ElSelect,
    ElOption,
    DatePicker,
    PdfPickerModal,
    getPDF,
    "album-and-swipe-picker": AlbumAndSwipePicker,
    CountrySelector
  },
  data() {
    const title = "ข้อมูลใบเสร็จ";
    const form = {
      name: "",
      tempName: "",
      taxId: "",
      tempTaxId: "",
      branchNumber: "",
      tempBranchNumber: "",
      issuedAt: DateTime.utc(),
      tempIssuedAt: DateTime.utc(),
      receiptDeleteReason: "",
    };
    const issuedAtDialog = {
      isShow: false,
      title: "เปลี่ยนแปลงวันที่",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "บันทึก",
      disableSubmit: false,
    };
    const addBranchNumberDialog = {
      isShow: false,
      title: "เพิ่มเลขสาขา",
      subTitle: "ระบุเลขสาขาด้วยตัวเลข 5 หลัก กรณีที่เป็นสำนักงานใหญ่ให้ระบุเป็น 00000",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "บันทึก"
    };
    const editBranchNumberDialog = {
      isShow: false,
      title: "เปลี่ยนเลขสาขา",
      subTitle: `ระบุเลขสาขาด้วยตัวเลข 5 หลัก กรณีที่เป็นสำนักงานใหญ่ให้ระบุเป็น 00000`,
      buttonCancel: "ยกเลิก",
      buttonSubmit: "บันทึก",
      disableSubmit: false
    };
    const confirmDialog = {
      isShow: false,
      title: "เปลี่ยนแปลงชื่อลูกค้า",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "บันทึก",
      disableSubmit: false,
    };
    const addressDialog = {
      isShow: false,
      title: "เปลี่ยนแปลงที่อยู่",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "บันทึก",
      disableSubmit: false,
    };
    const taxIdDialog = {
      isShow: false,
      title: "เปลี่ยนแปลงเลขประจำตัวผู้เสียภาษี",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "บันทึก",
      disableSubmit: false,
    }
    const confirmDeleteReceiptDialog = {
      isShow: false,
      title: "ยืนยันการลบตัวอย่างใบเสร็จ",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "ยืนยัน",
    };
    const addressForm = {
      zip_code: null,
      province_code: null,
      amphur_code: null,
      tumbon: null,
      address: null,
      intlAddress: null,
      countryCode: null,
      countryName: null,
    };
    const tempAddressForm = {
      zip_code: null,
      province_code: null,
      amphur_code: null,
      tumbon: null,
      address: null,
      intlAddress: null,
      countryCode: null,
      countryName: null,
    };

    const permission = JSON.parse(localStorage.getItem("adminRolePermission")) || null;

    const languageOptions = [
      {
        label: "ไทย",
        value: localization.TH,
        icon: "/static/icons/language-th-icon.svg",
      },
      {
        label: "English",
        value: localization.EN,
        icon: "/static/icons/language-en-icon.svg",
      }
    ]

    const addressOptions = [
      { label: "ที่อยู่ภายในประเทศ", value: "DOMESTIC" },
      { label: "ที่อยู่ต่างประเทศ", value: "INTERNATIONAL" }
    ];

    const selectedAddress = {
      current: null,
      temp: null,
      value: null
    };

    return {
      title,
      rawReceipt: null,
      isSending: false,
      prevRoute: null,
      form,
      issuedAtDialog,
      addBranchNumberDialog,
      editBranchNumberDialog,
      confirmDialog,
      addressDialog,
      taxIdDialog,
      confirmDeleteReceiptDialog,
      addressForm,
      tempAddressForm,
      clientAddressForm: null,
      firstRun: true,
      initialTumbons: [],
      searchTumbons: null,
      receiptDeleteReason: "",
      isShowSelectPdfDialog: false,
      fileOfflinePdfUrl: null,
      isShowSelectWithholdingImageAlbum: false,
      withholdingTaxKeyAlbum: [],
      canNotEditAddress: false,
      permission,
      showErrorDialog: false,
      nameError: '',
      languageOptions,
      selectedLanguage: null,
      addressOptions,
      selectedAddress,
      addressError: '',
      intlAddressError: '',
      countryOptions: getCountries(),
      tempAddressForm,
      decryptedId: null,
      isHiddenDrecryptButton: false,
      tax_id_to_pdf: null
    };
  },
  watch: {
    "form.tempIssuedAt": function (val) {
      this.issuedAtDialog.disableSubmit = !val;
    },
    "form.tempName": function (val) {
      this.confirmDialog.disableSubmit = !val;
    },
    "form.tempTaxId": function (val) {
      this.taxIdDialog.disableSubmit = !val;
    },
    "form.tempBranchNumber": function (val) {
      this.editBranchNumberDialog.disableSubmit = !val;
    },
    "addressForm.zip_code": function (val) {
      this.addressDialog.disableSubmit = !val;
    },
    "addressForm.province_code": function (val) {
      this.addressDialog.disableSubmit = !val;
    },
    "addressForm.amphur_code": function (val) {
      this.addressDialog.disableSubmit = !val;
    },
    "addressForm.tumbon": function (val) {
      this.addressDialog.disableSubmit = !val;
    },
    "addressForm.address": function (val) {
      this.addressDialog.disableSubmit = !val;
    },
    "addressForm.intlAddress": function (val) {
      this.addressDialog.disableSubmit = !val;
    },
    "addressForm.countryCode": function (val) {
      this.addressDialog.disableSubmit = !val;
    },
    "selectedAddress.temp": async function () {
      await this.validateSelectedAddress(this.addressForm, this.isIntlAddressSelected);
    },
    "selectedLanguage.value": async function () {
      this.addressForm = {
        ...this.addressForm,
        language: this.getLangCode()
      };

      await this.validateSelectedAddress(this.addressForm, this.isIntlAddressSelected);
      await this.updateReceiptAddress(this.addressForm);
    },
  },
  computed: {
    isEditTaxId() {
      return (
        !R.isEmpty(this.form.taxId) &&
        this.form.taxId != this.rawReceipt.tax_id_field
      );
    },
    itemPresenters() {
      if (!this.rawReceipt) {
        return [];
      }

      return this.rawReceipt.items.slice(1);
    },
    tumbons() {
      return this.searchTumbons || this.initialTumbons;
    },
    receipt() {
      if (!this.rawReceipt) {
        return null;
      }
      
      const no = this.rawReceipt.is_offline_receipt
        ? 'ใบเสร็จนอกระบบ'
        : this.rawReceipt.id;
      const createdDate = DateTime.fromISO(this.rawReceipt.created_date)
        .setZone("utc+7")
        .setLocale("th")
        .toFormat("dd/MM/yyyy");
      const issuedAt = this.form.issuedAt
        .setZone("utc+7")
        .setLocale("th")
        .toFormat("dd/MM/yyyy");

      const line1 = this.createAddressLine1();
      const line2 = this.createAddressLine2();

      const client = {
        name: this.rawReceipt.name,
        addressLine1: line1,
        addressLine2: line2,
        taxId: this.rawReceipt.tax_id_field
      };

      const price = this.rawReceipt.items
        && this.rawReceipt.items.length > 0
        && this.rawReceipt.items[0].amount
        ? this.rawReceipt.items[0].amount
        : undefined

      const packageName = this.isEnglish
        ? this.rawReceipt.package_name_en
        : this.rawReceipt.package_name;

      const item = {
        name: packageName,
        duration: this.rawReceipt.package_duration,
        price,
        quantity: this.rawReceipt.quantity,
        subscriptionId: this.rawReceipt.subscription_id
      };
      const summary = {
        referenceBasisAmount: this.rawReceipt.reference_basis_amount
          ? this.rawReceipt.reference_basis_amount
          : null,
        amountBeforeVat: this.rawReceipt.basis_price,
        differenceBasisAmount: this.rawReceipt.difference_basis_amount
          ? this.rawReceipt.difference_basis_amount
          : null,
        vat: this.rawReceipt.tax,
        grandTotal: this.rawReceipt.total_amount
      };

      let pdfUrl = this.rawReceipt.pdf_url;

      if (this.form.issuedAt) {
        pdfUrl += "&issued_at=" + encodeURIComponent(this.form.issuedAt.toISO());
      }

      if (this.form.name) {
        pdfUrl += "&name=" + encodeURI(this.form.name);
      }

      const taxId = this.isEditTaxId ? this.form.taxId : this.rawReceipt.tax_id_field;

      pdfUrl += "&line1=" + encodeURI(line1);
      pdfUrl += "&tax_id=" + encodeURI(taxId);

      if (line2 && line2 !== "") {
        const line2SplitArray = line2.split(" ");
        pdfUrl += "&zip_code=" + encodeURI(line2SplitArray[line2SplitArray.length - 1]);

        line2SplitArray.pop();
        pdfUrl += "&line2=" + encodeURI(line2SplitArray.join(" "));
      }

      if (this.hasBranchNumber) {
        pdfUrl += "&branch_number=" + encodeURI(this.form.branchNumber);
      }

      const purpose = this.rawReceipt.purpose
        ? this.rawReceipt.purpose
        : null;

      const referenceDocumentNumber = this.rawReceipt.reference_document_number
        ? this.rawReceipt.reference_document_number
        : null;

      const invoiceId = this.rawReceipt.invoice_id
        ? this.rawReceipt.invoice_id
        : null;

      const { seller_trade_party_name, seller_trade_party_name_en } = this.rawReceipt;
      const sellerTradePartyName = this.isEnglish
        ? seller_trade_party_name_en
        : seller_trade_party_name;

      if (this.rawReceipt.user_tax_invoice
        && this.rawReceipt.user_tax_invoice.branch_no
        && !this.rawReceipt.receipt_billing_address ) {
        this.form.branchNumber = this.rawReceipt.user_tax_invoice.branch_no
      }

      return {
        no,
        createdDate,
        issuedAt,
        client,
        item,
        summary,
        pdfUrl,
        purpose,
        referenceDocumentNumber,
        sellerTradePartyName,
        invoiceId,
        type: receiptTypeTH[this.rawReceipt.type],
        canDelete: this.rawReceipt.can_delete,
        canSendToEztax: this.rawReceipt.can_send_to_eztax,
        canResendToEztax: this.rawReceipt.can_resend_to_eztax,
        fileOfflineName: this.rawReceipt.offline_pdf_name || null,
        fileOfflinePdfKey: this.rawReceipt.offline_pdf_key || null,
        isOfflineReceipt: this.rawReceipt.is_offline_receipt || null,
        isDuplicateReceiptByInvoice: this.rawReceipt.is_duplicate_receipt_by_invoice || false,
        isManualPayment: this.rawReceipt.is_manual_payment || false,
      };
    },
    showPreviewReceiptButton() {
      return !this.rawReceipt.appointment_no
    },
    showDeletePreviewReceiptButton() {
      return this.rawReceipt.can_delete
    },
    showSendReceiptButton() {
      return (this.rawReceipt.can_send_to_eztax || this.rawReceipt.can_resend_to_eztax)
    },
    showConfirmReceiptButton() {
      return this.rawReceipt.can_confirm
    },
    isSuccessToSentEztax() {
      return this.rawReceipt.is_success_to_send_eztax
    },
    zipCodes() {
      if (!this.tumbons.length) {
        return [];
      }

      return R.pipe(R.map(R.path(["zip_code"])), R.uniq)(this.tumbons);
    },
    provinces() {
      return R.uniqBy(R.path(["province_code"]), 
      this.tumbons.filter(item => item.zip_code === this.addressForm.zip_code));
    },
    amphurs() {
      if (!this.addressForm.province_code) {
        return [];
      }

      return R.pipe(
        R.filter(R.propEq("province_code", this.addressForm.province_code)),
        R.uniqBy(R.path(["amphur_code"]))
      )(this.tumbons.filter(item => item.zip_code === this.addressForm.zip_code));
    },
    selectableTumbons() {
      if (!this.addressForm.amphur_code) {
        return [];
      }

      return this.tumbons.filter(({ amphur_code, zip_code }) => {
        return (
          amphur_code === this.addressForm.amphur_code &&
          zip_code === this.addressForm.zip_code
        );
      });
    },
    isCreditNote() {
      return this.receipt.type === receiptTypeTH.CREDIT_NOTE;
    },
    hasBranchNumber() {
      return !R.isEmpty(this.form.branchNumber);
    },
    selectPdfDialog() {
      return {
        isShow: this.isShowSelectPdfDialog,
        title: "เลือก PDF",
        isLoading: false,
        fileName: this.receipt.fileOfflineName
      }
    },
    isHasToEditOwnerName() {
      return this.rawReceipt.has_edited_owner_name === false
        && this.form.tempName === this.receipt.client.name
        && this.rawReceipt.is_user_for_offline_purchase_by_admin === true
    },
    isHasToEditOwnerTaxId() {
      return this.rawReceipt.has_edited_owner_tax_id === false
        && this.form.taxId === this.receipt.client.taxId
        && this.rawReceipt.is_user_for_offline_purchase_by_admin === true
    },
    isOfflineUser() {
      return this.rawReceipt.is_user_for_offline_purchase_by_admin
    },
    selectWithholdingImageAlbumDialog() {
      return {
        isShow: this.isShowSelectWithholdingImageAlbum,
        title: "Withholding Tax Album",
        album: this.isShowSelectWithholdingImageAlbum
          ? this.rawReceipt.withholding_images
          : undefined,
        canEdit: true,
        imageName: "withholding_tax",
        titleForChooseImage: "เลือกรูป หัก ณ ที่จ่าย",
        pathImage: "withholding_tax",
        isNotMakePublicImage: true
      };
    },
    isViewOnlyByRole() {
      const roles = ["AC"]
      return roles.includes(this.permission.role)
    },
    isBlockSendReceiptByHalfHourFirst() {
      const currentTime = new Date();
      const minutes = currentTime.getMinutes();
      
      return minutes >= 0 && minutes < 30;
    },
    isEnglish() {
      return this.selectedLanguage && this.selectedLanguage.value === localization.EN || false;
    },
    isIntlAddressSelected() {
      return this.selectedAddress.value === this.getAddressType(1);
    },
    isTempIntlAddressSelected() {
      return this.selectedAddress.temp === this.getAddressType(1);
    },
  },
  created() {
    this.setup();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  methods: {
    async setup() {
      await this.setupData();
      await this.setupForm();
    },
    async setupData() {
      await this.setupRawReceipt();
      await this.setupInitialTumbons();
    },
    async setupRawReceipt() {
      const result = await this.fetchData();

      this.setupLanguage(result.address);

      this.rawReceipt = result;

      const offlinePdfKey = result.offline_pdf_key
        ? await getPDF(result.offline_pdf_key, "receipt")
        : null;

      this.fileOfflinePdfUrl = offlinePdfKey;
    },
    async setupInitialTumbons() {
      const zip_code = this.rawReceipt.address ? this.rawReceipt.address.zip_code : this.rawReceipt.home.zip_code;
      const params = { zip_code: zip_code };
      const response = await baanRueJaiClient.admin.addresses.list(params);

      this.initialTumbons = response.data.result;
    },
    getDefaultLanguage(language) {
      const defaultLanguage = language && language === "en"
        ? localization.EN
        : localization.TH;
        
      return defaultLanguage;
    },
    async setupLanguage(address) {
      const defaultLanguage = this.getDefaultLangOrFallback(address);

      this.selectedLanguage =
        this.languageOptions.find(language => language.value === defaultLanguage);
    },
    getDefaultLangOrFallback(address) {
      return address ? this.getDefaultLanguage(address.language) : localization.TH;
    },
    async setupForm() {
      this.setupIssuedAtForm();
      this.setupNameAndTaxIdForm();
      this.setupBranchNumber();
      this.setupAddressForm();
    },
    setupIssuedAtForm() {
      const issuedAt = this.rawReceipt.issued_at
        ? DateTime.fromISO(this.rawReceipt.issued_at)
        : DateTime.fromISO(this.rawReceipt.created_date);

      this.form.issuedAt = issuedAt;
      this.form.tempIssuedAt = issuedAt;
    },
    setupNameAndTaxIdForm() {
      this.form.name = this.receipt.client.name.trim();
      this.form.tempName = this.form.name;
      this.form.taxId = this.receipt.client.taxId
      this.form.tempTaxId = this.receipt.client.taxId
    },
    setupAddressForm() {
      this.canNotEditAddress = userTaxInvoice
        && this.rawReceipt.can_resend_to_eztax
        && this.rawReceipt.can_resend_to_eztax === true

      const { home, address } = this.rawReceipt;
      const {
        zip_code,
        province_name,
        amphur_name,
        tumbon_name,
        international_address: intlAddress,
        country_code: countryCode,
        country_name: countryName
      } = address ? address : home;

      const userTaxInvoice = this.rawReceipt.user_tax_invoice || undefined
      const zipCode = userTaxInvoice ? userTaxInvoice.zip_code : zip_code
      const provinceName = userTaxInvoice ? userTaxInvoice.province : province_name
      const amphurName = userTaxInvoice ? userTaxInvoice.amphur : amphur_name
      const tumbonName = userTaxInvoice ? userTaxInvoice.tumbon : tumbon_name

      // Set default address type
      const domesticAddressType = this.getAddressType(0);
      const intlAddressType = this.getAddressType(1);
      const currentAddress = intlAddress
        ? intlAddressType
        : domesticAddressType;

      this.selectedAddress = {
        current: currentAddress,
        temp: currentAddress,
        value: currentAddress
      };

      // Set default address form
      const isTumbonsNotEmpty = this.tumbons && this.tumbons.length > 0;
      const defaultProvinceCode = isTumbonsNotEmpty
        ? this.tumbons.find(t => t.province_name === provinceName).province_code
        : null;
      const defaultAmphurCode = isTumbonsNotEmpty
        ? this.tumbons.find(t => t.amphur_name === amphurName).amphur_code
        : null;
      const defaultTumbon = isTumbonsNotEmpty
        ? this.tumbons.find(t => t.tumbon_name === tumbonName)
        : null;
      const defaultAddress = address && address.address
        ? address.address
        : this.rawReceipt.line_one;
      const defaultIntlAddress = intlAddress
        ? intlAddress
        : null;

      this.addressForm = {
        zip_code: zipCode,
        province_code: defaultProvinceCode,
        amphur_code: defaultAmphurCode,
        tumbon: defaultTumbon,
        address: defaultAddress,
        intlAddress: defaultIntlAddress,
        countryCode,
        countryName
      };

      this.tempAddressForm = {
        zip_code: zipCode,
        province_code: defaultProvinceCode,
        amphur_code: defaultAmphurCode,
        tumbon: defaultTumbon,
        address: defaultAddress,
        intlAddress: defaultIntlAddress,
        countryCode,
        countryName
      };

      // Set address error
      this.addressError = !defaultAddress ? 'กรุณาใส่ที่อยู่' : '';
      this.intlAddressError = !defaultIntlAddress ? 'กรุณาใส่ที่อยู่' : '';
    },
    setupBranchNumber() {      
      let currentBranchNumber = ""
      if (existValueAndEmptyString(this.rawReceipt.branch_number)) {
        currentBranchNumber = this.rawReceipt.branch_number
      } else if (
        this.rawReceipt.user_tax_invoice
        && existValueAndEmptyString(this.rawReceipt.user_tax_invoice.branch_no)
      ) {
        currentBranchNumber = this.rawReceipt.user_tax_invoice.branch_no
      }

      this.form.branchNumber = currentBranchNumber;
      this.form.tempBranchNumber = currentBranchNumber;
    },
    async fetchData() {
      const { id } = this.$route.params;
      const response = await baanRueJaiClient.admin.subscriptions.receipts.get(
        id
      );

      return response.data.result;
    },
    async handlePreviewReceipt(url, language) {
      try {
        const response = await baanRueJaiClient.admin.subscriptions.receipts.previewPdf(
          url,
          language
        );

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const blobUrl = window.URL.createObjectURL(blob);

        window.open(blobUrl, '_blank');
      } catch (error) {
        let errorMessage = "ไม่สามารถเปิดไฟล์ PDF ได้";
        const blob = error.response && error.response.data
          ? error.response.data
          : null;

        if (blob instanceof Blob && blob.type.toLowerCase().includes('json')) {
          const text = await blob.text();
          const json = text ? JSON.parse(text) : {};

          errorMessage = json.message || errorMessage;
        } else if (error.response && error.response.data) {
          errorMessage = error.response.data.message || errorMessage;
        }

        alert(errorMessage);
      }
    },
    async handleClickSendReceiptButton(key) {
      const { isValid, error } = isValidReceiptUserName(this.form.name);

      if (isValid) {
        if (this.isBlockSendReceiptByHalfHourFirst === true) {
          alert("ไม่สามารถส่ง eztax ตอนครึ่งชั่วโมงแรกได้ เพราะระบบ run auto");
          return;
        }

        if (key === "CONFIRM") {
          if (!confirm(`ยืนยันการจอง "เลขที่ใบเสร็จ" และข้อมูลใบเสร็จ`)) {
            return;
          }
        } else {
          if (
            !confirm(
              `ยืนยันการส่ง${this.receipt.type}\nหมายเหตุ: หากต้องการจัดส่งในนามนิติบุคคล กรุณาเพิ่มเลขสาขา`
            )
          ) {
            return;
          }
        }

        const taxIdEdited = this.form.taxId ? this.form.taxId : undefined;

        const taxId = this.isEditTaxId
          ? this.form.taxId
          : this.rawReceipt.tax_id_field;

        try {
          this.isSending = true;

          const id = this.$route.params.id;
          const params = this.hasBranchNumber
            ? {
                branch_number: this.form.branchNumber,
                tax_id: taxId,
                issued_at: this.form.issuedAt.toISO(),
                name: this.form.name,
                address:
                  this.clientAddressForm || this.rawReceipt.receipt_address,
                withholding_images: this.withholdingTaxKeyAlbum,
                invoice_id: this.rawReceipt.invoice_id,
              }
            : {
                issued_at: this.form.issuedAt.toISO(),
                name: this.form.name,
                address:
                  this.clientAddressForm || this.rawReceipt.receipt_address,
                tax_id: taxIdEdited,
                withholding_images: this.withholdingTaxKeyAlbum,
                invoice_id: this.rawReceipt.invoice_id,
              };

          if (!["CONFIRM", "SEND"].includes(key))
            throw new Error("ไม่ได้ระบุชนิดของใบเสร็จ");

          if (key === "CONFIRM") {
            await baanRueJaiClient.admin.subscriptions.receipts.postConfirm(
              id,
              params
            );
          }

          if (key === "SEND") {
            // Send To Eztax
            if (this.receipt.canSendToEztax) {
              await baanRueJaiClient.admin.subscriptions.receipts.postSend(
                id,
                this.selectedLanguage.value
              );
            }

            // Resend To Eztax
            if (this.receipt.canResendToEztax) {
              await baanRueJaiClient.admin.subscriptions.receipts.postResend(
                id,
                this.selectedLanguage.value
              );
            }
          }

          // const fromExternal =
          //   this.prevRoute === null || this.prevRoute.name === null;
          // const route = fromExternal
          //   ? { name: "ReceiptDashboardPage" }
          //   : { name: this.prevRoute.name, params: this.prevRoute.params };

          window.location.reload();
        } catch (err) {
          console.error(err);
          this.isSending = false;

          if (err.response && err.response.data && err.response.data.message) {
            if (
              err.response.data.errorCode === "PAYMENT_RESPONSE_NOT_MATCH_ERR"
            ) {
              alert("ระบบเช็คการตัดเงินไม่สำเร็จ (payment not match)");
              return;
            }

            alert(err.response.data.message);
          } else if (err.message) {
            alert(err.message);
          } else {
            alert("ไม่สามารถส่ง eztax ได้ กรุณาลองใหม่อีกครั้ง");
          }
        }
      } else {
        this.nameError = error;
        this.showErrorDialog = true;
      }
    },
    handleClickChangeAddressButton() {
      this.addressDialog.isShow = true;
    },
    async updateReceiptAddress(addressForm) {
      const { id } = this.$route.params;
      const {
        tumbon,
        address,
        intlAddress,
        countryCode,
        countryName,
        language
      } = addressForm || {};

      if (!tumbon && !address && !intlAddress && !countryCode) {
        return;
      }

      const params = {
        name: this.form.name,
        issued_at: this.form.issuedAt,
        tax_id: this.form.taxId,
        branchNumber: this.form.branchNumber || null,
        address: {
            ...tumbon,
            ...address ? { address } : {},
            ...intlAddress && countryCode
              ? {
                  international_address: intlAddress,
                  country_code: countryCode,
                  country_name: countryName
                }
              : {},
            language
          }
      };
      
      // Update address
      await baanRueJaiClient.admin.subscriptions.receipts.updateReceiptInformation(
        id,
        params
      );
      this.isHiddenDrecryptButton = false
    },
    async handleConfirmAddress(isConfirm) {
      try {
        // Cancel
        if (!isConfirm) {
          this.addressDialog.isShow = false;
          if (this.clientAddressForm) {
            this.addressForm = { ...this.clientAddressForm };
          } else {
            this.addressForm = { ...this.tempAddressForm };
          }

          this.searchTumbons = null;

          this.selectedAddress = {
            ...this.selectedAddress,
            temp: this.selectedAddress.current
          };

          return;
        }

        // Get address form
        const {
          address: addressInput,
          intlAddress: intlAddressInput,
          countryCode: countryCodeInput
        } = this.addressForm;

        // Validate address form
        const isAddressError = this.isTempIntlAddressSelected
          ? await this.validateAddressForm(intlAddressInput, true)
          : await this.validateAddressForm(addressInput);
        if (isAddressError) {
          return;
        }

        // Validate selected country code for international address
        if (this.isTempIntlAddressSelected && !countryCodeInput) {
          return;
        }

        // Set selected address
        const { temp } = this.selectedAddress;
        this.selectedAddress = {
          ...this.selectedAddress,
          current: temp,
          value: temp
        };

        // Set address form
        const baseAddressForm = {
          ...this.addressForm,
          language: this.getLangCode()
        };
        const { address: tempAddress } = this.tempAddressForm;

        this.clientAddressForm = this.isTempIntlAddressSelected ? {
          ...baseAddressForm,
          ...tempAddress ? { address: tempAddress } : {},
          intlAddress: intlAddressInput,
          countryCode: countryCodeInput,
          countryName: getCountryByCode(countryCodeInput).name
        } : {
          ...baseAddressForm,
          address: addressInput,
          intlAddress: null,
          countryCode: null,
          countryName: null
        };

        await this.updateReceiptAddress(this.clientAddressForm);

        // Set language
        this.rawReceipt.address = { ...this.clientAddressForm };
        this.setupLanguage(this.rawReceipt.address);

        this.addressDialog.isShow = false;
        //เมื่อกดบันทึกจะไม่ให้กดส่ง EZTax เลยต้องกดยืนยันข้อมูลก่อน
        this.rawReceipt.can_confirm = true
        this.rawReceipt.can_send_to_eztax = false
        this.rawReceipt.can_resend_to_eztax = false
        this.isHiddenDrecryptButton = false
      } catch (error) {
        alert("ไม่สามารถเปลี่ยนที่อยู่ได้");
      }
    },
    async validateSelectedAddress(addressForm, isTempIntlAddressSelected = false) {
      if (!addressForm) {
        return;
      }

      if (isTempIntlAddressSelected) {
        await this.validateAddressForm(addressForm.intlAddress, true);
      } else {
        await this.validateAddressForm(addressForm.address);
      }
    },
    async validateAddressForm(address, isIntlAddress = false) {
      const errorField = isIntlAddress
        ? 'intlAddressError'
        : 'addressError';

      if (!address) {
        this[errorField] = "กรุณาใส่ที่อยู่";

        return true;
      }

      const isValid = await this.validateEnglishInput(address)

      if (!isValid) {
        this[errorField] = "กรอกเฉพาะภาษาที่เลือกเท่านั้น";

        return true;
      }

      this[errorField] = "";

      return false;
    },
    handleClickChangeClientNameButton() {
      this.confirmDialog.isShow = true;
    },
    handleClickChangeTaxIdButton() {
      this.taxIdDialog.isShow = true;
    },
    handleClickDeleteReceiptButton() {
      this.confirmDeleteReceiptDialog.isShow = true;
    },
    async handleConfirm(isConfirm) {
      try {
        if (!isConfirm) {
          this.confirmDialog.isShow = false;
          this.form.tempName = this.form.name
          return;
        }

        const { id } = this.$route.params;
        this.form.name = this.form.tempName;
        const params = {
          name: this.form.name,
          issued_at: this.form.issuedAt,
          tax_id: this.form.taxId,
          branchNumber: this.form.branchNumber || null,
          address:
                  this.clientAddressForm || this.rawReceipt.receipt_address,
        };

        const result =
          await baanRueJaiClient.admin.subscriptions.receipts.updateReceiptInformation(
            id,
            params
          );
        this.confirmDialog.isShow = false;
        //เมื่อกดบันทึกจะไม่ให้กดส่ง EZTax เลยต้องกดยืนยันข้อมูลก่อน
        this.rawReceipt.can_confirm = true
        this.rawReceipt.can_send_to_eztax = false
        this.rawReceipt.can_resend_to_eztax = false
        this.isHiddenDrecryptButton = false
      } catch (error) {
        alert("ไม่สามารถเปลี่ยนชื่อได้");
      }
    },
    async handleConfirmTaxId(isConfirm) {
      try {
        if (!isConfirm) {
          this.taxIdDialog.isShow = false;
          this.form.tempTaxId = this.form.taxId;
          return;
        }
        
        const { id } = this.$route.params;
        this.form.taxId = this.form.tempTaxId;
        const params = {
          name: this.form.name,
          issued_at: this.form.issuedAt,
          tax_id: this.form.taxId,
          branchNumber: this.form.branchNumber || null,
          address:
          this.clientAddressForm || this.rawReceipt.receipt_address,
        };
    
        const result =
          await baanRueJaiClient.admin.subscriptions.receipts.updateReceiptInformation(
            id,
            params
          );
        this.taxIdDialog.isShow = false;
        //เมื่อกดบันทึกจะไม่ให้กดส่ง EZTax เลยต้องกดยืนยันข้อมูลก่อน
        this.rawReceipt.can_confirm = true
        this.rawReceipt.can_send_to_eztax = false
        this.rawReceipt.can_resend_to_eztax = false
        this.isHiddenDrecryptButton = false
      } catch (error) {
        alert("ไม่สามารถเปลี่ยนเลขประจำตัวผู้เสียภาษีได้");
      }
    },
    async handleConfirmCancel(isConfirm) {
      if (!isConfirm) {
        this.confirmDeleteReceiptDialog.isShow = false;
        return;
      }

      try {
        const { id } = this.$route.params;
        const params = { purpose: this.receiptDeleteReason };

        const result = await baanRueJaiClient.admin.subscriptions.receipts.postDeleteExampleReceipt(
          id,
          params
        );

        alert("ลบตัวอย่างใบเสร็จสำเร็จ");
        this.$router.push({ name: "ReceiptDashboardPage" });
      } catch (e) {
        alert("ไม่สามารถลบตัวอย่างใบเสร็จได้");
        throw e;
      }
    },
    async handleSearchZipCode(queryString) {
      const params = { zip_code: queryString };
      const response = await baanRueJaiClient.admin.addresses.list(params);

      this.searchTumbons = response.data.result;
    },
    async handleChangeAddressForm(key, value) {
      this.addressForm[key] = value;

      switch (key) {
        case "zip_code":
          this.handleChangeAddressZipCodeForm(value);
        case "amphur_code":
          this.handleChangeAddressAmphurCodeForm(value);
        default:
          break;
      }
    },
    async handleChangeAddressZipCodeForm(val) {
      
      // Reset Adress Form
      if (!val) {
        this.addressForm.province_code = null
        this.addressForm.amphur_code = null
        this.addressForm.tumbon = null
        return
      }

      // Validate Search Tumbons
      if (!Array.isArray(this.searchTumbons)) return
      
      // Filter Tumbons
      const tumbons =  this.searchTumbons.filter(
        e => e.zip_code === val
      )
      // Validate Tumbons
      if (tumbons.length  == 0) return 

      // Address Props
      const [{ province_code, amphur_code }] = tumbons

      // Set Address Form
      this.addressForm.province_code = province_code
      this.addressForm.amphur_code = amphur_code
      this.addressForm.tumbon = tumbons
    },
    async handleChangeAddressAmphurCodeForm(val) {
      if (!val) {
        return;
      }

      switch (this.selectableTumbons.length) {
        case 1:
          this.addressForm.tumbon = this.selectableTumbons[0];
          break;
        default:
          this.addressForm.tumbon = null;
          break;
      }
    },
    handleClickChangeIssuedAtButton() {
      this.issuedAtDialog.isShow = true;
    },
    handleClickAddBranchNumberButton() {
      this.addBranchNumberDialog.isShow = true;
    },
    handleClickEditBranchNumberButton() {
      this.editBranchNumberDialog.isShow = true;
    },
    async handleConfirmAddBranchNumber(isConfirm) {
      if (!isConfirm) {
        this.addBranchNumberDialog.isShow = false;
        this.form.tempBranchNumber = "";
        return;
      }

      try {
        this.addBranchNumberDialog.isShow = false;
        this.form.branchNumber = this.form.tempBranchNumber;
        const { id } = this.$route.params;
        const params = {
          name: this.form.name,
          issued_at: this.form.issuedAt,
          tax_id: this.form.taxId,
          branch_number: this.form.branchNumber,
          address:
          this.clientAddressForm || this.rawReceipt.receipt_address,
        };
        
        const result =
          await baanRueJaiClient.admin.subscriptions.receipts.updateReceiptInformation(
            id,
            params
          );
        //เมื่อกดบันทึกจะไม่ให้กดส่ง EZTax เลยต้องกดยืนยันข้อมูลก่อน
        this.rawReceipt.can_confirm = true
        this.rawReceipt.can_send_to_eztax = false
        this.rawReceipt.can_resend_to_eztax = false
        this.isHiddenDrecryptButton = false
      } catch (error) {
        alert("ไม่สามารถเพิ่มเลขสาขาผู้เสียภาษีได้");
      }
    },
    async handleConfirmEditBranchNumber(isConfirm) {
      try {
        if (!isConfirm) {
          this.editBranchNumberDialog.isShow = false;
          this.form.tempBranchNumber = this.form.branchNumber
          return;
        }
       
        const { id } = this.$route.params; 
        this.form.branchNumber = this.form.tempBranchNumber;
        const params = {
          name: this.form.name,
          issued_at: this.form.issuedAt,
          tax_id: this.form.taxId,
          branch_number: this.form.branchNumber,
          address:
          this.clientAddressForm || this.rawReceipt.receipt_address,
        };

        const result =
          await baanRueJaiClient.admin.subscriptions.receipts.updateReceiptInformation(
            id,
            params
          );
        this.editBranchNumberDialog.isShow = false;
        //เมื่อกดบันทึกจะไม่ให้กดส่ง EZTax เลยต้องกดยืนยันข้อมูลก่อน
        this.rawReceipt.can_confirm = true
        this.rawReceipt.can_send_to_eztax = false
        this.rawReceipt.can_resend_to_eztax = false
        this.isHiddenDrecryptButton = false
      } catch (error) {
        alert('ไม่สามารถเพิ่มเลขสาขาผู้เสียภาษีได้');
      }
    },
    async handleConfirmIssuedAt(isConfirm) {

      try {
        if (!isConfirm) {
          this.issuedAtDialog.isShow = false;
          this.form.tempIssuedAt = this.form.issuedAt
          return;
        }

        const { id } = this.$route.params;
        this.form.issuedAt = this.form.tempIssuedAt;
        const params = {
          name: this.form.name,
          issued_at: this.form.issuedAt,
          tax_id: this.form.taxId,
          branchNumber: this.form.branchNumber || null,
          address:
          this.clientAddressForm || this.rawReceipt.receipt_address,
        };

        const result =
          await baanRueJaiClient.admin.subscriptions.receipts.updateReceiptInformation(
            id,
            params
          );
        this.issuedAtDialog.isShow = false;
        //เมื่อกดบันทึกจะไม่ให้กดส่ง EZTax เลยต้องกดยืนยันข้อมูลก่อน
        this.rawReceipt.can_confirm = true
        this.rawReceipt.can_send_to_eztax = false
        this.rawReceipt.can_resend_to_eztax = false
        this.isHiddenDrecryptButton = false
      } catch (error) {
        alert('ไม่สามารถเปลี่ยนวันที่ได้');
      }
    },
    handleClickAddOfflinePdfReceiptButton() {
       this.isShowSelectPdfDialog = true;
    },
    handleCancelSelectPdfDialog() {
      this.isShowSelectPdfDialog = false;
    },
    async handleConfirmSelectPdfDialog(pdfFile) {
      const offlinePdfKey = !R.isNil(pdfFile)
        ? await uploadPublicFile(pdfFile, "receipt")
        : null;

      const offlinePdfName = !R.isNil(pdfFile)
        ? pdfFile.name
        : null

      const params = {
        offline_pdf_key: offlinePdfKey,
        offline_pdf_name: offlinePdfName
      }

      const { id } = this.$route.params;

      try {
        await baanRueJaiClient.admin.subscriptions.receipts.putOfflinePdf(
          id,
          params
        );

        await this.setup();
      } catch(e) {
        console.error(e)
        alert('ไม่สามารถบันทึก ใบเสร็จนอกระบบได้');
        return
      }

      this.isShowSelectPdfDialog = false;
    },
    async handleFileNotChangedPdfDialog(pdfFile) {
      if (!pdfFile) {
        await this.handleConfirmSelectPdfDialog(null);
      }

      this.isShowSelectPdfDialog = false;
    },
    handleClickAddSelectWithholdingAlbumDialog() {
      this.isShowSelectWithholdingImageAlbum = true;
    },
    handleCancelSelectWithholdingAlbumDialog() {
      this.isShowSelectWithholdingImageAlbum = false;
    },
    async handleConfirmSelectWithholdingAlbumDialog(album) {
      const withholdingTaxKeyAlbum = album
        && album.allImageToAlbum
        && album.allImageToAlbum.length > 0
        ? getKeyByUrlPath(album.allImageToAlbum)
        : undefined

      if (!this.rawReceipt.invoice_id) {
        alert('ไม่สามารถบันทึกรูปใบกำกับภาษี หรือ ไม่มีข้อมูลใบกำกับภาษี');
        return
      }

      this.rawReceipt.withholding_images = withholdingTaxKeyAlbum && album.allImageToAlbum
        ? album.allImageToAlbum
        : []

      this.withholdingTaxKeyAlbum = withholdingTaxKeyAlbum || []
      this.isShowSelectWithholdingImageAlbum = false;

      if (
        !this.showSendReceiptButton
        && !this.receipt.isDuplicateReceiptByInvoice
      ) {
        this.updateWithholdingTaxAlbum()
      }
    },
    async updateWithholdingTaxAlbum() {
      try {
        await baanRueJaiClient.admin.subscriptions.receipts.putWithholdingTaxImageKeys(
          this.rawReceipt.invoice_id,
          {
            withholding_tax_keys: this.withholdingTaxKeyAlbum
              && this.withholdingTaxKeyAlbum.length > 0
              ? this.withholdingTaxKeyAlbum
              : null
          }
        );

        this.isShowSelectWithholdingImageAlbum = false;
        alert("บันทึกเรียบร้อย");
      } catch(e) {
        console.error(e)
        alert('ไม่สามารถบันทึก รูปใบกำกับได้');
        return
      }
    },
    async handleDecryptTaxId() {
      try {
        const { id } = this.$route.params;
        const response = await backendAdminClient.receipt.getDecryptedTaxId(id);

        this.receipt.client.taxId = response.data.result.tax_id;
        this.isHiddenDrecryptButton = true;
      } catch (error) {
        alert("ไม่สามารถเข้าถึงได้");
      }
    },
    createAddressLine1() {
      const { rawReceipt, clientAddressForm } = this;

      if (clientAddressForm && clientAddressForm.intlAddress) {
        return clientAddressForm.intlAddress;
      }

      if (clientAddressForm && clientAddressForm.address) {
        return clientAddressForm.address;
      }
      
      if (rawReceipt && rawReceipt.address && rawReceipt.address.international_address) {
        return rawReceipt.address.international_address;
      }

      return rawReceipt.line_one.replace(/null/g, "");
    },
    createAddressLine2() {
      const { rawReceipt, clientAddressForm } = this;

      if (clientAddressForm && clientAddressForm.countryName) {
        return clientAddressForm.countryName;
      }
      
      if (clientAddressForm && clientAddressForm.tumbon) {
        return this.formattedAddress(clientAddressForm.tumbon);
      }

      if (rawReceipt && rawReceipt.address && rawReceipt.address.country_name) {
        return rawReceipt.address.country_name;
      }

      if (rawReceipt && rawReceipt.address) {
        return this.formattedAddress(rawReceipt.address);
      }

      return rawReceipt.line_two.replace(/null/g, "");
    },
    formattedAddress(address) {
      const addressParts = this.isEnglish ? [
        address.pre_tumbon_en,
        address.tumbon_name_en,
        address.pre_amphur_en,
        address.amphur_name_en,
        address.province_name_en,
        address.zip_code
      ] : [
        `${address.pre_tumbon}${address.tumbon_name}`,
        `${address.pre_amphur}${address.amphur_name}`,
        address.province_name,
        address.zip_code
      ];

      return addressParts.join(' ').trim();
    },
    getLangCode() {
      return this.isEnglish ? "en" : "th";
    },
    getAddressType(index) {
      return this.addressOptions[index].value;
    },
    isLangDefault() {
      const defaultLanguage = this.getDefaultLangOrFallback(this.rawReceipt.address);
      
      return this.selectedLanguage && this.selectedLanguage.value === defaultLanguage;
    },
    async validateEnglishInput(input) {
      if (!this.isEnglish) {
        return true;
      }

      const regex = /^[A-Za-z0-9\s.,/-]*$/;

      return regex.test(input);
    },
    handleCountrySelected(value) {
      this.addressForm.countryCode = value;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.container {
  padding-top: $space;
  padding-bottom: $space;
}

.label {
  font-size: 14px;
  color: #777;
}

.preview {
  display: inline-block;
  border-radius: 5px;
  border: 1px solid #dcdfe6;
  min-width: 120px;
  padding: 8px 30px;
  font-size: 1rem;
  text-align: center;
  background: white;
  cursor: pointer;

  &:hover {
    text-decoration: none;
    color: black;

    background: #efefef;
  }
}

.name {
  width: 250px;
}

.branch-number {
  width: 250px;
}

.offline-user {
  font-size: 18px;
  color: rgb(252, 76, 76);
}

.offline-user-detail {
  font-size: 14px;
  color: rgb(252, 76, 76);
}

.button-content {
  width: 200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  font-size: 16px;
  color: #4a4a4a;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  outline: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease;
}

.button-content:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.el-select-dropdown__item {
  margin-block: 8px;
}

.warning {
  font-size: 13px;
  color: rgb(252, 76, 76);
}

.address-options {
  display: flex;
  flex-direction: column;
}

.el-input,
.el-textarea,
.el-select {
  width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/receipts/pages/ReceiptDetailPage.vue